import { render, staticRenderFns } from "./CollapseInfo.vue?vue&type=template&id=d94ec4b8"
import script from "./CollapseInfo.vue?vue&type=script&lang=ts"
export * from "./CollapseInfo.vue?vue&type=script&lang=ts"
import style0 from "./CollapseInfo.vue?vue&type=style&index=0&id=d94ec4b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports